export default store => {
  return {
    async getStaticPageData(params) {
      return await store.dispatch(`pages/fetch`, params);
    }
  };
};
